module.exports = __webpack_public_path__ + "img/app-store.82062dab.svg";